<div #trigger="cdkOverlayOrigin" cdkOverlayOrigin>
  @if (!menuText) {
    <button
      class="flex justify-center items-center p-0 three-dots-btn"
      data-test-id="dropdown-trigger"
      [class.open]="isOpen"
      [disabled]="disabled"
      (click)="toggle($event)"
    >
      <svg class="icon" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M13.2175 19.7915C13.2175 21.2326 12.0499 22.4003 10.6088 22.4003C9.16769 22.4003 8 21.2326 8 19.7915C8 18.3504 9.16769 17.1827 10.6088 17.1827C12.0499 17.1827 13.2175 18.3504 13.2175 19.7915ZM22.6097 19.7915C22.6097 21.2326 21.442 22.4003 20.001 22.4003C18.5599 22.4003 17.3923 21.2326 17.3923 19.7915C17.3923 18.3504 18.5599 17.1827 20.001 17.1827C21.442 17.1827 22.6097 18.3504 22.6097 19.7915ZM29.3914 22.4003C30.8325 22.4003 32.0002 21.2326 32.0002 19.7915C32.0002 18.3504 30.8325 17.1827 29.3914 17.1827C27.9504 17.1827 26.7827 18.3504 26.7827 19.7915C26.7827 21.2326 27.9504 22.4003 29.3914 22.4003Z"
          fill="#04293E"
        />
      </svg>
    </button>
  }

  @if (menuText) {
    <app-new-button
      [loading]="loading"
      [saveButtonSizeDuringLoading]="saveButtonSizeDuringLoading"
      [size]="'responsive'"
      [type]="buttonType"
      [svgIconPath]="buttonSvgIconPath"
      [backgroundMode]="'light'"
      (click)="toggle($event)"
    >
      {{ menuText }}
    </app-new-button>
  }
</div>

<ng-template
  cdkConnectedOverlay
  [cdkConnectedOverlayOrigin]="trigger"
  [cdkConnectedOverlayOpen]="isOpen"
  [cdkConnectedOverlayPanelClass]="'dropdown-control-overlay'"
  [cdkConnectedOverlayPositions]="overlayPosition ? [overlayPosition] : undefined"
  [cdkConnectedOverlayHasBackdrop]="true"
  [cdkConnectedOverlayBackdropClass]="'cdk-overlay-transparent-backdrop'"
  (backdropClick)="close()"
>
  <app-dropdown-options-backdrop data-test-id="three-dots-menu-dropdown" [class]="listWidth">
    @for (menuAction of menuActions; track $index) {
      <app-dropdown-option-with-submenu
        #option
        [menuAction]="menuAction"
        [context]="context"
        (click)="close()"
      ></app-dropdown-option-with-submenu>
    }
    <ng-content></ng-content>
  </app-dropdown-options-backdrop>
</ng-template>
